export const defaultRepeatObj = {
  repeat: "never",
  frequency: "daily",
  everyFrequency: 1,
  startsOn: null,
  dates: [],
  endsOn: null,
  shiftOccurText: "",
  recurrenceWeekDays: [],
  recurrenceMonthDates: [],
  recurrenceYearDayOfWeek: ["First"],
  recurrenceYearWeekDay: ["Monday"],
  recurrenceYearMonths: ["January"],
};

export const defaultVariousTime = {
  startTime: false,
  endTime: false,
  breakTime: false,
  adminTime: false,
};

export const TOUR_STEPS = [
  {
    target: ".tour-clientSidebar-dashboard",
    content:
      "The Dashboard is your central point of control, offering a snapshot of key information and a quick overview of your upcoming locum bookings.",
    disableBeacon: true,
    placement: "right-bottom",
  },
  {
    target: ".tour-candidate-types",
    content: "Gain access to all your modules directly from the dashboard.",
    // disableBeacon: true,
    placement: "right-bottom",
  },
  {
    target: ".tour-dashboard-upcoming-booking",
    content:
      "View your latest current or upcoming bookings at your site by clicking on the tile for more details.",
    placement: "right",
  },
  {
    target: ".tour-dashboard-shift-schedule",
    content:
      "Get a visual view of your bookings via the calendar, which highlights dates that you have shifts booked in on.",
    // disableBeacon: true,
    placement: "right",
  },
  {
    target: ".tour-dashboard-oneMonth-calendar",
    content:
      "Clicking on a date tile will highlight all dates and present them on the schedule list . This will also show the current day, week and month.",
    placement: "left",
  },
  {
    target: ".tour-header-main-search",
    content: "Search candidates or contracts directly from the global search.",
    // placement: "left"
  },

  {
    target: ".tour-invited-clientsidebar",
    content: "Your own invited candidates can be found here.",
    placement: "right-bottom",
  },
  {
    target: ".tour-invited-actions",
    content: "Select any candidate and take some actions.",
  },
  {
    target: ".tour-invited-button",
    content:
      "The Invite feature allows you to efficiently invite direct locums and new candidates for open shifts by inviting them to AppLocum.",
  },
  {
    target: ".tour-invited-bulk-invites",
    content:
      "The Bulk features allows you to invite bulk candidates by uploading a CSV/xlsx file. This feature is useful for inviting multiple candidates at once and helps streamline the process.",
  },
  {
    target: ".tour-invited-search",
    content:
      "The Search and filter feature allows you to search and filter for specific candidates by name, email, or role etc. This feature is useful for finding candidates quickly and easily.",
  },
  {
    target: ".tour-unfilled-clientsidebar",
    content:
      "The unfilled module shows all of your published unfulfilled contracts.",
    placement: "right-bottom",
  },
  {
    target: ".tour-unfilled-actions",
    content: "Select any contract and take some actions.",
  },
  {
    target: ".tour-applied-clientsidebar",
    content:
      "You can explore all of your published contracts with applied candidates in the applied module.",
    placement: "right-bottom",
  },
  // {
  //   target: ".tour-applied-heading",
  //   content: "You can explore all of your published contracts with applied candidates in the applied module."
  // },
  {
    target: ".tour-applied-actions",
    content: "Select any applied candidate and take some actions.",
  },
  {
    target: ".tour-booked-clientsidebar",
    content:
      "Any shifts that candidates have been booked in for can be viewed within the 'Booked' module.",
    placement: "right-bottom",
  },
  // {
  //   target: ".tour-booked-heading",
  //   content: "Any shifts that candidates have been booked in for can be viewed within the 'Booked' module. "
  // },
  {
    target: ".tour-booked-actions",
    content: "Select any booked candidate and take some actions.",
  },
  {
    target: ".tour-booked-switch-button",
    content:
      "A contract view and a shift view are available.The contract view can be expanded to display shifts. ",
  },

  {
    target: ".tour-worked-clientsidebar",
    content:
      "Any past shifts that have been worked by candidates can be viewed within the 'Worked' module.",
    placement: "right-bottom",
  },

  // {
  //   target: ".tour-worked-heading",
  //   content: "Any past shifts that have been worked by candidates can be viewed within the 'Worked' module."
  // },
  {
    target: ".tour-worked-actions",
    content: "Select any worked candidate and take some actions.",
  },
  {
    target: ".tour-worked-switch-button",
    content:
      "A contract view and a shift view are available.The contract view can be expanded to display shifts.",
  },
  {
    target: ".tour-timesheet-types",
    content:
      "Gain access to all your modules directly from the Timesheet module.",
  },
  {
    target: ".tour-submitted-clientsidebar",
    content:
      "The Submitted module shows all of the timesheets that candidates have worked.",
    placement: "right-bottom",
  },
  {
    target: ".tour-submitted-actions",
    content: "Select the shift you wish to Approve, Reject or Amend. ",
  },
  {
    target: ".tour-authorised-clientsidebar",
    content:
      "View all historic authorised timesheets on your site with visibility of who authorised them.",
    placement: "right-bottom",
  },
  {
    target: ".tour-authorised-actions",
    content: "Select the shift you wish to export this information.",
  },

  {
    target: ".tour-terminated-clientsidebar",
    content:
      "View all historic terminated timesheets on your site with visibility of who terminated them.",
    placement: "right-bottom",
  },
  {
    target: ".tour-terminated-actions",
    content: "Select the shift you wish to export this information.",
  },
  {
    target: ".tour-job-rate-clientsidebar",
    content: "You can manage all of your job rates in the 'Job Rates' module.",
    placement: "right-bottom",
  },
  // {
  //   target: ".tour-qr-code",
  //   content: "QR Code"
  // },
  {
    target: ".tour-job-rate-delete-action",
    content: "Select any job rate and delete any job rate you wish.",
  },
  {
    target: ".tour-add-job-rates",
    content:
      "You can add new job rates by clicking on the 'Add Job Rates' button. This will allow you to create new job rates for your future post jobs.",
  },
  {
    target: ".tour-add-job-rates-role-des",
    content:
      "To add job rates for a Role, Please select roles and provide a description.",
  },
  {
    target: ".tour-applocum-invoice-clientsidebar",
    content: "You can manage all of your invoices in the 'Invoices' module.",
    placement: "right-bottom",
  },
  {
    target: ".tour-applocum-invoice-action",
    content: "You can download and export invoices by selecting any invoice.",
  },
  {
    target: ".tour-applocum-download-clientsidebar",
    content: "Your multiple invoices are downloaded in the 'Downloads module'.",
    placement: "right-bottom",
  },
  {
    target: ".tour-applocum-branch-management",
    content:
      "Users will gain visibility of other sites through branch management. ",
  },
  {
    target: ".tour-appcloum-my-profile-clientsidebar",
    content: "Edit your profile .",
    placement: "top-bottom",
  },

  {
    target: ".tour-appcloum-my-profile-update",
    content:
      "Edit your profile details such as Name and Phone number in the 'My Profile' section.",
  },
  {
    target: ".tour-applocum-client-profile-update",
    content:
      "Edit Practice Profile details such as address and Post code in the 'My Profile' Section.",
  },
  {
    target: ".tour-reset-clientuser-password",
    content:
      "To Change your password, Enter your existing one and then the new password you wish to use.",
  },
  {
    target: ".tour-client-role-user-clientsidebar",
    content:
      "Manage your multiple users via user access Firstly, set up roles with access you wish to provide.",
  },
  {
    target: ".tour-client-role-action",
    content: "Select any role and take some actions.",
  },
  {
    target: ".tour-client-add-role",
    content:
      "You can add new roles by clicking on the 'Add Role' button. This will allow you to create new roles for your users.",
  },
  {
    target: ".tour-client-user-action",
    content: "Select any user and take some actions.",
  },
  {
    target: ".tour-client-user-set-primary",
    content: "You may change ownership transfers.",
  },
  {
    target: ".tour-client-user-add-user",
    content:
      "You can add new users by clicking on the 'Add User' button. This will allow you to create new users for your site.",
  },
];

export const toggleOptions = [
  {
    id: "override",
    title: "Override candidate’s restrictions",
    description:
      "Once overriding compliance, the candidate will get 15 days to submit their compliance documents",
  },
  {
    id: "preferred",
    title: "Mark as preferred candidate",
    description: "Prioritise this candidate for future locum opportunities",
  },
  {
    id: "autoApprove",
    title: "Auto-Approve Candidate",
    description:
      "Allow this candidate to be automatically approved for relevant roles",
  },
  {
    id: "unsuitable",
    title: "Mark as Unsuitable Candidate",
    description: "Exclude this candidate from future job matches.",
  },
];

export const defaultAllPermission = {
  is_admin: false,
  is_allow_to_unfilled_list: true,
  is_allow_to_invited_list: true,
  is_allow_to_applied_list: true,
  is_allow_to_booked_list: true,
  is_allow_to_worked_list: true,
  is_allow_to_assigned_timesheet_list: true,
  is_allow_to_submitted_timesheet_list: true,
  is_allow_to_authorised_timesheet_list: true,
  is_allow_to_terminated_timesheet_list: true,
  is_allow_to_invoice_list: true,
  is_allow_to_users_and_roles_list: true,
  is_allow_to_create_candidates: true,
  is_allow_to_edit_candidates: true,
  is_allow_to_upload_candidates_resumes: true,
  is_allow_to_upload_candidate_compliance: true,
  is_allow_to_proposed_candidates: true,
  is_allow_to_signoff_timesheets: true,
  is_allow_to_create_invoices: true,
  is_allow_to_view_candidate_profile: true,
  is_allow_to_view_contract_detail: true,
  is_allow_to_global_search: true,
  is_allow_to_export_records: true,
  is_allow_to_view_download_compliance: true,
  is_allow_to_export_invoice: true,
};

export const checkPremiumPermission = [];

export const allPermissionsData = [
  {
    value: "is_allow_to_unfilled_list",
    label: "Unfilled Contracts",
    type: "module",
  },
  {
    value: "is_allow_to_invited_list",
    label: "Invited Candidates",
    type: "module",
  },
  {
    value: "is_allow_to_applied_list",
    label: "Applied Candidates",
    type: "module",
  },
  {
    value: "is_allow_to_booked_list",
    label: "Booked Shifts / Contracts",
    type: "module",
  },
  {
    value: "is_allow_to_worked_list",
    label: "Worked Shifts / Contracts",
    type: "module",
  },
  {
    value: "is_allow_to_assigned_timesheet_list",
    label: "Assigned Timesheets",
    type: "module",
  },
  {
    value: "is_allow_to_submitted_timesheet_list",
    label: "Submitted Timesheets",
    type: "module",
  },
  {
    value: "is_allow_to_authorised_timesheet_list",
    label: "Authorised Timesheets",
    type: "module",
  },
  {
    value: "is_allow_to_terminated_timesheet_list",
    label: "Terminated Timesheets",
    type: "module",
  },
  {
    value: "is_allow_to_invoice_list",
    label: "Invoices",
    type: "module",
  },
  {
    value: "is_allow_to_view_candidate_profile",
    label: "Candidate Profile",
    type: "module",
  },
  {
    value: "is_allow_to_view_contract_detail",
    label: "Contract Details",
    type: "module",
  },
  {
    value: "is_allow_to_global_search",
    label: "Global Search",
    type: "module",
  },
  {
    value: "is_allow_to_users_and_roles_list",
    label: "User Access",
    type: "module",
  },
  // Feature permissions
  {
    value: "is_allow_to_create_candidates",
    label: "Create Candidates",
    type: "feature",
  },
  {
    value: "is_allow_to_edit_candidates",
    label: "Edit Candidates",
    type: "feature",
  },
  {
    value: "is_allow_to_upload_candidates_resumes",
    label: "Upload Candidate Resumes",
    type: "feature",
  },
  {
    value: "is_allow_to_upload_candidate_compliance",
    label: "Upload Candidate Compliance",
    type: "feature",
  },
  {
    value: "is_allow_to_proposed_candidates",
    label: "Propose Candidates",
    type: "feature",
  },
  {
    value: "is_allow_to_signoff_timesheets",
    label: "Sign Off Timesheets",
    type: "feature",
  },
  {
    value: "is_allow_to_create_invoices",
    label: "Create Invoices",
    type: "feature",
  },
  {
    value: "is_allow_to_view_download_compliance",
    label: "View / Download Compliance",
    type: "feature",
  },
  {
    value: "is_allow_to_export_invoice",
    label: "Export Invoice",
    type: "feature",
  },
];

export const getDefaultRow = (mode) => {
  let isEdit = mode === "edit";
  return {
    payRate: isEdit ? 0 : "",
    days: "",
    jobStartTime: isEdit ? "00:00" : "",
    jobEndTime: isEdit ? "00:00" : "",
    isValid: false,
  };
};

const defaultPayRateObject = {
  payRate: "",
  days: "",
  jobStartTime: "",
  jobEndTime: "",
  isValid: false,
};

export const clientAllBankJobPayRates = [
  "Weekday",
  "Evening",
  "Overnight",
  "Saturday",
  "Sunday",
  "Bank Holiday",
  "Exception",
  "Admin",
  "Custom 1",
  "Custom 2",
].map((standard) => ({
  standard,
  customPayName: standard,
  ...defaultPayRateObject,
}));

export const clientAvailableJobRatesDay = [
  {
    value: "Monday",
    label: "Monday",
  },
  {
    value: "Tuesday",
    label: "Tuesday",
  },
  {
    value: "Wednesday",
    label: "Wednesday",
  },
  {
    value: "Thursday",
    label: "Thursday",
  },
  {
    value: "Friday",
    label: "Friday",
  },
  {
    value: "Saturday",
    label: "Saturday",
  },
  {
    value: "Sunday",
    label: "Sunday",
  },
  {
    value: "Bank Holiday",
    label: "Bank Holiday",
  },
];

export const staticJobStandardName = [
  {
    value: "Weekday",
    label: "Weekday",
  },
  {
    value: "Evening",
    label: "Evening",
  },
  {
    value: "Overnight",
    label: "Overnight",
  },
  {
    value: "Saturday",
    label: "Saturday",
  },
  {
    value: "Sunday",
    label: "Sunday",
  },
  {
    value: "Bank Holiday",
    label: "Bank Holiday",
  },
  {
    value: "Exception",
    label: "Exception",
  },
  {
    value: "Admin",
    label: "Admin",
  },
  {
    value: "Custom 1",
    label: "Custom 1",
  },
  {
    value: "Custom 2",
    label: "Custom 2",
  },
];
